<template>
  <div id="app">
    <Navbar />
    <router-view />
    <Footer />
    <FloatingAside />
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import Footer from './components/Footer.vue'
import FloatingAside from './components/FloatingAside.vue'

export default {
  name: 'App',
  components: {
    Navbar,
    Footer,
    FloatingAside
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'PingFang SC', 'Microsoft YaHei', sans-serif;
  line-height: 1.6;
  color: #334155;
  background: #f5f9ff;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

a {
  text-decoration: none;
}

/* 固定顶栏占位，锚点滚动时不被遮挡 */
main section[id] {
  scroll-margin-top: 96px;
}
</style>
